<div class="wrapper" (click)="onSelect()">

  <div class="titleContainer">
    <tun-scrollable-text class="title" [text]="musicCollection.title"></tun-scrollable-text>
  </div>

  <tun-tweak-context-icon-v5 *ngIf="!isPlaylist" class="icon icon-scaled-svg-button"></tun-tweak-context-icon-v5>
  <tun-tweak-playlist-icon-v5 *ngIf="isPlaylist" class="icon icon-scaled-svg-button"></tun-tweak-playlist-icon-v5>
</div>
